module.exports = __webpack_public_path__ + "img/15.0b18d9b2.jpg";